"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_lines_ellipsis_1 = tslib_1.__importDefault(require("react-lines-ellipsis"));
var responsiveHOC_1 = tslib_1.__importDefault(require("react-lines-ellipsis/lib/responsiveHOC"));
var ResponsiveEllipsis = responsiveHOC_1.default()(react_lines_ellipsis_1.default);
/**
 * @public
 */
var InsightTitle = function (_a) {
    var title = _a.title;
    return (react_1.default.createElement("div", { className: "insight-title-outer" },
        react_1.default.createElement("div", { className: "insight-title" },
            react_1.default.createElement(ResponsiveEllipsis, { text: title, maxLine: 2, ellipsis: "...", className: "item-headline-inner s-headline" }))));
};
exports.default = InsightTitle;
//# sourceMappingURL=InsightTitle.js.map